module.exports = __webpack_public_path__ + "img/cheng.adbdc7dc.png";